import { PauseIcon, PlayIcon } from '@heroicons/react/24/solid';
import { MediaPlayButton } from 'media-chrome/react';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';
import { useMediaPauseRequest } from '@/lib/hooks/media-controller/useMediaPauseRequest';

import { defaultButtonStyling } from './util';

import type { MediaPlayButton as MediaPlayButtonElement } from 'media-chrome';

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  mediaController?: string;
  onPause?: () => void;
}

export function PlayerPlayToggleButton({
  size = 'md',
  mediaController,
  onPause,
}: Props) {
  const playButtonRef = useMediaPauseRequest<MediaPlayButtonElement>(onPause);

  return (
    <MediaPlayButton
      ref={playButtonRef}
      mediaController={mediaController}
      style={defaultButtonStyling}
    >
      <span slot="play">
        <Button aria-hidden="true" tabIndex={-1} size={size}>
          <HeroIcon icon={PlayIcon} />
        </Button>
      </span>
      <span slot="pause">
        <Button aria-hidden="true" tabIndex={-1} size={size}>
          <HeroIcon icon={PauseIcon} />
        </Button>
      </span>
    </MediaPlayButton>
  );
}
